
import type { Accessor } from "solid-js"

export interface HasFloorElevationAccessor {
  floor_e: Accessor<number>
}

export function byHasFloorElevationAccessorDesc(
  a: HasFloorElevationAccessor | null,
  b: HasFloorElevationAccessor | null): number {
  return (b?.floor_e() ?? -Infinity) - (a?.floor_e() ?? -Infinity)
}